import React, { Component } from 'react';
import Icon from 'components/Icon';
import Drag from 'components/Drag';
import { 
	handles,
	dividings,
	getDefaultImagePath,
	getDefaultPreviewPath,
	getDefaultAreaCls,
	showdate,
	showtime,
	showweather,
} from 'components/Playlist';
import { 
	mathMultiply,
	RGB2RGBA,
} from '@/utils/common';
import { Img } from 'components/Material';
import './style/index.less';

export default class WorkArea extends Component {
	constructor(){
		super();
		// this.state = {
		// 	opacity: 1
		// }
	}
	isInCheckedKeys = (areaId) => {
		let { checkedKeys } = this.props;
		let flag = checkedKeys.some((checkedKey) => {
			return checkedKey === areaId + '';
		})
		return flag;
	}
	render() {
		// const {
		// 	opacity
		// } = this.state;
		let {
			type,
			workbenchLeft,
			workbenchTop,
			workbenchWidth,
			workbenchHeight,
			templatewidth,
			templateheight,
			divcompare,

			areaArray,
			currentArea,

			onCancelLine,
			onDrag,
			onChange,
			onDragEnter,
			onDragOver,
			onDrop,

			onTop,
			onBottom,
			onUp,
			onDown,
			onDelete,
			onClear,
			onMax,
			onLock,
			onAnchor,
			onUpdateArea,
			onShowMaterialModel,
		} = this.props;
		// areaArray.sort((obj1, obj2) => {			
		// 	return obj2.zIndex - obj1.zIndex;
		// })
		let scaleOrigin = 'scale(' + 1 / divcompare + ')';
		let scale = 'scale(' + divcompare + ')';
		let origin = '0 0';
		if(type === 'scene') {
			scale = 'scale(' + divcompare + ')';
			origin = '0 0';
			divcompare = 1;
		}
		
		return (
			<div
				className={'playlist-workbench'}
				style={{
					position: 'relative',
					left: workbenchLeft,
					top: workbenchTop,
					width: workbenchWidth,
					height: workbenchHeight,
					transform: scale,
					transformOrigin: origin,
				}}
			>
				{(areaArray || []).map((area, index) => {
					let { left, top, width, height, areaId, areaType, mediaAreas, lock, anchor_type} = area;
					if(-1 === areaType || 43 === areaType) return null;
					let imageOrTextareaComponent = null;
					if(2 === areaType){
						let { content, family, color, size, opacity, bgcolor, } = area.textArea;
						opacity = (100 - parseInt(opacity.replace("%", ""))) + "%";
						imageOrTextareaComponent = (<textarea 
							className={'div-img'} 
							value={content}
							placeholder={content ? '' : window.language['playlist.enter.content']}
							wrap={'off'}
							style={{
								position: 'absolute', 
								top: 0, 
								left: 0, 
								width: '100%', 
								height: '100%', 
								lineHeight: '100%',
								wordWrap: 'normal',
								overflow: 'hidden',
								backgroundColor: RGB2RGBA(bgcolor, opacity),
								fontFamily: family,
								fontSize: size,
								textAlign: 'left',
								border: 0,
								resize: 'none', 
								color: color,
							}}
							onChange={(event) => {
								onUpdateArea && onUpdateArea(event, 'textArea', 'content', event.target.value);
							}}
						/>);
					}else if(3 === areaType){
						let { color, family, size, style, } = area.dateArea;
						
						let content = showdate(style);
						imageOrTextareaComponent = (<div 
							className={'div-img'} 
							wrap={'off'}
							style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', lineHeight: height + 'px',
								wordWrap: 'normal',
								overflow: 'hidden',
								backgroundColor: 'transparent',
								fontFamily: family,
								fontSize: size,
								textAlign: 'center',
								border: 0,
								color: color,
							}}
						>{content}</div>);
					}else if(4 === areaType){
						let { color, family, size, style, } = area.timeArea;
						
						let content = showtime(style);
						imageOrTextareaComponent = (<div 
							className={'div-img'} 
							wrap={'off'}
							style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', lineHeight: height + 'px',
								wordWrap: 'normal',
								overflow: 'hidden',
								backgroundColor: 'transparent',
								fontFamily: family,
								fontSize: size,
								textAlign: 'center',
								border: 0,
								color: color,
							}}
						>{content}</div>);
					}else if(5 === areaType){
						let { color, family, size, style, } = area.weatherArea;
						
						let content = showweather(style, size, family, color);
						imageOrTextareaComponent = (<div 
							className={'div-img'} 
							wrap={'off'}
							style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', /**lineHeight: height + 'px',*/
								backgroundColor: 'transparent',
							}}
						>{content}</div>);
					}else if(18 === areaType){
						let { 
							bold,
							italic,
							underline,
							align,
							size,
							family,
							familyId,
							color,
							content } = area.sTextArea;
						imageOrTextareaComponent = (<textarea 
							className={'div-img'} 
							value={content}
							placeholder={content ? '' : window.language['playlist.enter.content']}
							wrap={'off'}
							style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', lineHeight: height + 'px',
								border: 0,
								wordWrap: 'normal',
								overflow: 'hidden',
								backgroundColor: 'transparent',
								fontWeight: bold,
								fontStyle: italic,
								textDecoration: underline,
								fontSize: size,
								fontFamily: family,
								fontFamilyId: familyId,
								textAlign: align,
								color: color,
							}}
							onChange={(event) => {
								onUpdateArea && onUpdateArea(event, 'sTextArea', 'content', event.target.value);
							}}
						/>);
					}else{
						let src = getDefaultImagePath(areaType);
						let mediaAreasLength = mediaAreas.length;
						let lastMediaArea = null;
						if(mediaAreasLength > 0){
							lastMediaArea = mediaAreas[mediaAreasLength - 1];
							src = getDefaultPreviewPath(lastMediaArea, src);
						}
						let bgcolor = 'transparent';
						if(9 === areaType){
							bgcolor = area.bgArea.bgcolor;
						}
						if(src){
							imageOrTextareaComponent = (
								<Img 
									draggable={false}
									className={'div-img'}
									src={src} 
									style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', lineHeight: height + 'px'}}
								/>)
						}else{
							imageOrTextareaComponent = (<div className={'div-img'}
								style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', lineHeight: height + 'px',
									backgroundColor: bgcolor
								}}
							/>)
						}
					}
					
					// let display = this.isInCheckedKeys(areaId) ? 'block' : 'none';
					let display = 'block';
					let divStyle = {
						...area,
						// left: mathMultiply(left, divcompare),
						// top: mathMultiply(top, divcompare),
						// width: mathMultiply(width, divcompare),
						// height: mathMultiply(height, divcompare),
						left,
						top,
						width,
						height,
						textAlign: 'center',
						position: 'absolute',
						// opacity: currentArea === area ? opacity : "1",
						display,
					};
					let className = currentArea === area ? "workArea selected" : "workArea noselected";
					let workAreaContent = (
						<React.Fragment>
							{ imageOrTextareaComponent }
						</React.Fragment>
					);
					if(type !== 'scene') {
						workAreaContent = (
							<React.Fragment>
								{/* {
									anchor_type !== 1 ? <div className={'div-anchor'}>
									1<Icon type="play-circle" title={window.language['playlist.anchor']} />
								</div> : 
									<div className={'div-anchor'}>
										2<Icon type="play-circle" title={window.language['playlist.anchor']} />
									</div>
								} */}
								{ imageOrTextareaComponent }
								{
									lock ? (
										<div className={'div-lock'} style={{
												transform: scaleOrigin,
												transformOrigin: 'left 40px',
											}}>
											<div className={"div-bg1"} />
											<div className={"div-bg2"} />
											<Icon className="unlock-o" title={window.language['playlist.lock']} onClick={(event) => {
												onLock && onLock(event, 'workArea', area);
											}}/>
										</div>
									) : null
								}
								{
									anchor_type === 1 ? (
										<div className={'div-anchor'} style={{
												transform: scaleOrigin,
												transformOrigin: '80px 40px',
											}}>
											<div className={"div-bg1"} />
											<div className={"div-bg2"} />
											<Icon className={"anchor"} title={window.language['playlist.anchor']} onClick={(event) => {
												onAnchor && onAnchor(event, 'workArea', area);
											}}/>
										</div>
									) : null
								}
								<div className={'div-areatype'} style={{
										transform: scaleOrigin,
										transformOrigin: 'right 40px',
									}}>>
									<div className={"div-bg1"} />
									<div className={"div-bg2"} />
									<Icon className={getDefaultAreaCls(areaType)} />
								</div>
								{(handles || []).map((handle, index) => {
									if(9 === areaType) return null;
									return (
										<div
											key={index}
											style={{ 
												display: currentArea === area ? 'block' : 'none',
												transform: scaleOrigin,
												// transformOrigin: origin,
											}}
											className={handle}
										/>
									);
								})}
								{(dividings || []).map((dividing, index) => {
									if(9 === areaType) return null;
									return (
										<div
											key={index}
											style={{ 
												display: area[dividing] === dividing ? 'block' : 'none',
												transform: scaleOrigin,
												// transformOrigin: origin,
											}}
											className={dividing}
										/>
									);
								})}
							</React.Fragment>
						)
					}
					let dragDivProps = {
						key: areaId,
						className: className,
						style: divStyle,
						onMouseUp: () => {
							// this.setState({
							// 	opacity: 1
							// })
							onCancelLine && onCancelLine();
						},
						onChange: (resize) => {
							if(resize.areaName){
								// if(3 !== areaType && 4 !== areaType && 5 !== areaType){
									onChange && onChange(resize);
								// }
							}
						},
						onDragEnter: (event) => {
							onDragEnter && onDragEnter(event, 'workArea', area);
						},
						onDragOver: (event) => {
							onDragOver && onDragOver(event, 'workArea', area);
						},
						onDrop: (event) => {
							onDrop && onDrop(event, 'workArea', area);
						},
						// onContextMenu: (event) => {
						// 	event.stopPropagation();
						// 	event.preventDefault();
						// },
						onDoubleClick: (event) => {
							onShowMaterialModel && onShowMaterialModel(true, 'add')
						},
					}
					if (lock) {
						dragDivProps.onMouseDown = () => {
							if(area.areaName){
								onDrag && onDrag(area);
							}
						}
					}else{
						dragDivProps.onDrag = (drag) => {
							if(drag.areaName){
								onDrag && onDrag(drag);
							}
						}
					}
					return (
						lock || type === 'scene' ? (
							<div {...dragDivProps}>
								{
									workAreaContent
								}
							</div>
						) : (
							<Drag
								key={areaId}
								type={type}
								templatewidth={templatewidth}
								templateheight={templateheight}
								divcompare={divcompare}
								area={area}
							>
								<div {...dragDivProps}>
									{
										workAreaContent
									}
								</div>
							</Drag>
						)
					);
				})}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Playlist/WorkArea.js